<script setup lang="ts">
import { RouterLink, RouterView, useRouter, useRoute } from 'vue-router'
import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useTheme } from '@/composables/useTheme'

useTheme()

const auth = useAuthStore()
const router = useRouter()
const route = useRoute()

const isOnSettings = computed(() => route.name === 'settings')

function handleLogout() {
  auth.logout()
  router.push({ name: 'login' })
}
</script>

<template>
  <div class="h-full flex flex-col bg-slate-50 dark:bg-slate-950">
    <header
      class="bg-white dark:bg-slate-900 border-b border-slate-200 dark:border-slate-800 px-6 py-3 flex items-center justify-between shadow-sm"
    >
      <div class="flex items-center gap-3">
        <span class="inline-block w-2 h-6 bg-brand-600 rounded-sm"></span>
        <h1 class="text-base font-semibold text-slate-800 dark:text-slate-100">
          Kanban — Pablo Mendes
        </h1>
      </div>
      <div class="flex items-center gap-4">
        <template v-if="auth.isAuthenticated">
          <RouterLink
            v-if="auth.isAdmin && !isOnSettings"
            to="/settings"
            class="text-xs text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-100 flex items-center gap-1"
            title="Configurações do Kanban"
          >
            <span>⚙</span>
            <span>Configurações</span>
          </RouterLink>
          <RouterLink
            v-else-if="isOnSettings"
            to="/board"
            class="text-xs text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-100"
          >
            ← Board
          </RouterLink>
          <span class="text-sm text-slate-600 dark:text-slate-300">{{ auth.user?.name }}</span>
          <button
            type="button"
            class="text-xs text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-100 underline-offset-2 hover:underline"
            @click="handleLogout"
          >
            Sair
          </button>
        </template>
        <span class="text-xs text-slate-400 dark:text-slate-500 font-mono">v0.3.0</span>
      </div>
    </header>
    <main class="flex-1 overflow-hidden">
      <RouterView />
    </main>
  </div>
</template>
